import {
    forwardRef,
    useEffect,
    useImperativeHandle,
    useRef,
    useState
} from "react";
import "./css/DockPanel.css";

import { DockPosition } from "./DockIcons";

export interface DockPanelHandle {
    getHostElement: (id: string) => HTMLElement;
    remove: (id: string) => void;
}

interface DockEntryHost {
    id: string;
    host: HTMLElement;
}

export interface DockPanelProps {
    id: string;
    dock: DockPosition;
}

export const DockPanel = forwardRef<DockPanelHandle, DockPanelProps>(
    ({ id, dock: dock }, ref) => {
        const containerRef = useRef<HTMLDivElement>(null);
        const [hosts, setHosts] = useState<DockEntryHost[]>([]);

        // Host management
        const getHostElement = (id: string): HTMLElement => {
            const existing = hosts.find((h) => h.id === id);
            if (existing) return existing.host;

            const host = document.createElement("div");
            host.className = "dock-panel-item settle-effect";

            setHosts((prev) => [...prev, { id, host }]);
            return host;
        };

        const remove = (id: string) => {
            setHosts((prev) => {
                const entry = prev.find((h) => h.id === id);
                if (entry && containerRef.current?.contains(entry.host)) {
                    containerRef.current.removeChild(entry.host);
                }
                return prev.filter((h) => h.id !== id);
            });
        };

        useEffect(() => {
            const container = containerRef.current;
            if (!container) return;

            hosts.forEach(({ host }) => {
                if (!container.contains(host)) {
                    container.appendChild(host);
                }
            });
        }, [hosts]);

        useImperativeHandle(ref, () => ({
            getHostElement,
            remove
        }));


        return (
            <div id={id} ref={containerRef} className={`dock-panel dock-${dock}`}>

            </div>
        );
    }
);
